import { render } from "./anamneseExame2.vue?vue&type=template&id=617df8c8&scoped=true"
import script from "./anamneseExame2.vue?vue&type=script&lang=js"
export * from "./anamneseExame2.vue?vue&type=script&lang=js"

import "./anamneseExame2.vue?vue&type=style&index=0&id=617df8c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-617df8c8"]])

export default __exports__